import { Attr, Model } from "spraypaint";
import { JobClosedCategoryKey } from "../types/job";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class JobsClose extends ApplicationRecord {
  static jsonapiType = "jobs/close";

  @Attr() jobId: number;

  @Attr() closedReason: string;

  @Attr() closedReasonCategory: JobClosedCategoryKey;
}

export default JobsClose;
